// GameCard.js
import React from 'react';
import { Info } from 'lucide-react';
import { useModal } from '../helpers/ModalContext';

export default function GameCard({ game, onInfoClick }) {
  const { openModal } = useModal();

  
  return (
    <div className='game_card'>
      <img src={game.Thumbnail_Large} width="100%" />
      <div className='game_card_inner'>
        <Info
          color='white'
          style={{ alignSelf: 'end', cursor: 'pointer' }}
          onClick={() => onInfoClick(game)}
        />
        <button className='btn btn-primary' onClick={() => openModal(game)}>
          Play Now
        </button>
      </div>
    </div>
  );
}
